import React, { useState, useEffect } from "react";
import Loader from "../../components/Loader";
import axiosInstance from "../../utils/axiosInstance";
import { IoArrowBackSharp } from "react-icons/io5";

const PushNotification = () => {
  const [body, setBody] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axiosInstance.get("/users");
        setUsers(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };
    fetchUsers();
  }, []);

  const handleCheckboxChange = (userId) => {
    setSelectedUsers((prevSelectedUsers) => {
      if (prevSelectedUsers.includes(userId)) {
        return prevSelectedUsers.filter((id) => id !== userId);
      } else {
        return [...prevSelectedUsers, userId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(users.map((user) => user.id)); // Collect all IDs
    }
    setSelectAll(!selectAll);
  };

  const handleSendNotification = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axiosInstance.put("/notifications/users", {
        user_ids: selectedUsers,
        message: body,
      });
      if (response.status === 200) {
        setMessage("Notification sent successfully!");
      }
    } catch (error) {
      setMessage("Failed to send notifications.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex justify-center bg-gray-200 my-12">
      <div className="bg-white shadow-md rounded-lg p-6 max-w-md w-full">
        <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100 flex items-center">
          {/* Go Back Button */}
          <button
            onClick={() => window.history.back()} // This will navigate back to the previous page
            className="rounded-full hover:bg-gray-200 transition-all mr-2"
          >
            <IoArrowBackSharp size={24} />
          </button>{" "}
          Send Notification to Selected Users
        </h3>
        {message && (
          <p
            className={`text-center mb-4 ${
              message.includes("successfully")
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {message}
          </p>
        )}
        <form onSubmit={handleSendNotification}>
          <div className="mb-4">
            <label
              htmlFor="body"
              className="block text-gray-700 font-medium mb-2"
            >
              Message (supports HTML)
            </label>
            <textarea
              id="body"
              value={body}
              onChange={(e) => setBody(e.target.value)}
              rows="6"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <input
              type="checkbox"
              id="select-all"
              checked={selectAll}
              onChange={handleSelectAll}
              className="mr-2"
            />
            <label htmlFor="select-all" className="text-gray-700">
              Select All
            </label>
            <div className="h-32 overflow-y-scroll border rounded-md p-2">
              {loading ? (
                <Loader />
              ) : (
                users.map((user) => (
                  <div key={user.id} className="flex items-center mb-2">
                    <input
                      type="checkbox"
                      id={`user-${user.username}`}
                      checked={selectedUsers.includes(user.id)}
                      onChange={() => handleCheckboxChange(user.id)}
                      className="mr-2 cursor-pointer"
                    />
                    <label
                      htmlFor={`user-${user.username}`}
                      className="text-gray-700"
                    >
                      {user.username}
                    </label>
                  </div>
                ))
              )}
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-blue-600 transition-colors duration-200"
            disabled={isSubmitting || selectedUsers.length === 0}
          >
            {isSubmitting ? "Sending..." : "Send Notification"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PushNotification;
